import { render, staticRenderFns } from "./Comparador.vue?vue&type=template&id=6e2cf986"
import script from "./Comparador.vue?vue&type=script&lang=js"
export * from "./Comparador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports